import React, { useCallback, useState, useEffect } from 'react'
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import { StarTwoTone } from '@material-ui/icons';


const WorkflowTestAk = () => {
  const style         = SideStyle();
  const activeStep    = Param.Get('activeStep');
  const setup         = Param.Get('setup');
  const setParam      = Param.Get('setParam');
  const trim2         = Param.Get('trim2')
  const exportModel   = Param.Get('exportModel')

  const [startTime, setStartTime] = useState(null); // Tracks the start time of the current step.
  const [elapsedTimes, setElapsedTimes] = useState(Param.Get('elapsedTimes') || {}); // Stores the cumulative times for each step.

  // This is to accumulate the time for each step
  // This can't catch last step time, so we will also record start date and end date.
  // End date is defined as "Save Parameter" button click.
  // In the future We will make this time recording function as independent component if BK and AK are the same.
  const onClick = useCallback((step) => {
    const now = Date.now();
    if (startTime !== null && activeStep !== null) {
      const elapsedTime = now - startTime;
      setElapsedTimes(prevTimes => {
        const newTimes = { ...prevTimes, [activeStep]: (prevTimes[activeStep] || 0) + elapsedTime };
        setParam(s => { s.setup.elapsedTimes = newTimes });
        console.log(newTimes)
        return newTimes;
      });
    }
    setStartTime(now);
    setParam(s => { s.activeStep = step });
  }, [startTime, activeStep, setParam]);

  // This to stop the timer when the page is hidden
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Page is hidden, stop the timer
        setStartTime(null);
      } else {
        // Page is visible, start the timer
        setStartTime(Date.now());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Start date
  useEffect(() => {
    // This is to set the start time to the current time when the component mounts for active step 0
    setStartTime(Date.now());
    // Record exact date, second, minute, hour, day, year when activeStep is 0
    if (activeStep === 0 && setup.startDateTime == null) {
      const startDate = new Date();
      setParam(s => { s.setup.startDateTime = startDate });
      console.log(startDate);
      // Get the time zone
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setParam(s => { s.setup.timeZone = timeZone });
    }
  }, [])

  // End date
  useEffect(() => {
    if (exportModel >= 1) {
      const endDate = new Date();
      setParam(s => { s.setup.endDateTime = endDate });
      console.log(endDate);

      if (activeStep == 7) {
        const now = Date.now();
        const elapsedTime = now - startTime;
        setElapsedTimes(prevTimes => {
          const newTimes = { ...prevTimes, [activeStep]: (prevTimes[activeStep] || 0) + elapsedTime };
          setParam(s => { s.setup.elapsedTimes = newTimes });
          console.log(newTimes)
          return newTimes;
        });
      }
    }
  }, [exportModel])

  function getActive(step){
    if (activeStep == step) {
      return `${style.button} ${style.buttonSelected}`;
    } else if (activeStep >= step-1) {
      return style.button;
    } else {
      return style.buttonDisable;
    }
  }

  function getDisabled(step){
    if (activeStep == 5 && step == 5) {
      if (trim2.step == 1) {
        return false;
      } else {
        return true;
      }
    }
    if (activeStep >= step) {
      return false;
    } else {
      return true;
    }
  }

  // onclick bindling way is not proper, we would need to change function to class and use bind function.
  return(
    <div>
      <Box className={style.moduleTitle}>WorkFlow</Box>

      <div className={style.workflow}>
        {/* Line 1 */}
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}></Grid>
              <Grid item xs={10}>
                <Button className={getActive(0)} onClick={() => onClick(0)} size="small">Setup</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(1)} onClick={() => onClick(1)} size="small">Alignment</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(2)} onClick={() => onClick(2)} disabled={getDisabled(1)} size="small">Base Shape</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(3)} onClick={() => onClick(3)} disabled={getDisabled(2)} size="small">Compression</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Line 2 */}
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(4)} onClick={() => onClick(4)} disabled={getDisabled(3)} size="small">Lower trim</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(5)} onClick={() => onClick(5)} disabled={getDisabled(4)} size="small">Upper surface</Button>
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(6)} onClick={() => onClick(6)} disabled={getDisabled(5)} size="small">Assemble</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(7)} onClick={() => onClick(7)} disabled={getDisabled(6)} size="small">Output</Button>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
        <Box borderBottom={1}></Box>
      </div>
    </div>
  );
}
export default WorkflowTestAk;
